import React from 'react'

import StyleguidePreview from 'components/styleguide-preview'
import AttendeeList from 'components/attendee-list'

const AttendeeListPreview = () => {
  const attendees = [
    { name: 'Lucas', ticketType: ['General Admission'], ticketCount: [1], contact: 'test@test.com' },
    { name: 'Aaron', ticketType: ['VIP', 'Adult'], ticketCount: [2, 3], contact: 'aaron@test.com' },
    {
      name: 'Michele',
      ticketType: ['VIP'],
      ticketCount: [1],
      contact: 'michele@test.com',
      shared: [
        { name: 'Navin', ticketType: ['General Admission'], ticketCount: [2], contact: 'navin@test.com' },
        { name: 'Alex F.', ticketType: ['Adult', 'Children'], ticketCount: [1, 2], contact: 'alexf@test.com' },
        { name: 'Alex D.', ticketType: ['VIP'], ticketCount: [2], contact: 'alexd@test.com' },
      ],
    },
  ]

  return (
    <StyleguidePreview title="Attendee List">
      <AttendeeList attendees={attendees} />
    </StyleguidePreview>
  )
}

export default AttendeeListPreview



/** WEBPACK FOOTER **
 ** ./src/containers/styleguide/attendee-list-preview.js
 **/